import validate from "/Users/lion/Documents/work/outwork/website/nuxt3-template/node_modules/.pnpm/nuxt@3.10.0_eslint@8.56.0_sass@1.70.0/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/Users/lion/Documents/work/outwork/website/nuxt3-template/node_modules/.pnpm/nuxt@3.10.0_eslint@8.56.0_sass@1.70.0/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}